<template>
    <div class="w-full h-full">
        <FormModal v-if="showManualCashbackUpdate" @cancel="showManualCashbackUpdate = false; selectedCashback = undefined"
            @confirm="updateCashbackById()" title="Update cashback object" subtitle="Change the status of a cashback object"
            :valid="updateCashbackRequest.status != undefined" submitButtonText="Create Key">
            <CustomSelect v-model="updateCashbackRequest.status" :options="cashbackStatuses" label="Type" />
        </FormModal>
        <Header title="Cashback ledger" icon="BookOpenText" />
        <!--DELETE THIS WHITE BOX AFTER
        <WhiteBox
            title="Search for an end user (DELETE THIS AFTER MAKE USER SEARCH WORK IN BELOW TABLE)"
            subText="Find a users cashback object"
        >
            <template v-slot:content>
            <div class="flex w-full justify-left items-center text-center gap-3 mb-2 item-center">
                <CustomInput class="w-full" v-model="userSearch.userId" type="text" placeholder="User id" />
                <CustomButton class="w-32" id="viewPublisherButton" text="Search" icon="Search" type="action" @click="getCashbackObjectsForAnEndUser(0,50,userSearch)" />
            </div>
            </template>
</WhiteBox>-->
        <WhiteBox title="Explore the cashback ledger" subText="View the status of cashback objects">
            <template v-slot:buttons>
            </template>
            <template v-slot:content>
                <div class="grid grid-cols-1 xl:grid-cols-2 gap-x-2 mt-6">
                    <SearchBar placeholderText="Search by cashback id" @search="(val) => getCashbackFromId(val)">
                        <CustomButton small text="" type="default" icon="X" @click="getCashbackObjects(0, 50)" />
                    </SearchBar>
                    <SearchBar placeholderText="Search by user id"
                        @search="(val) => getCashbackObjectsForAnEndUser(0, 50, val)">
                        <CustomButton small text="" type="default" icon="X" @click="getCashbackObjects(0, 50)" />
                    </SearchBar>
                </div>
                <EasyDataTable :headers="headersTable1" :items="cashbackObjects" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="false"
                    :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #item-id="id">
                        <div class="w-20 py-1">
                            <p style="word-break:break-all; font-size:11px;">{{ id.id }}</p>
                        </div>
                    </template>
                    <template #item-createdOn="createdOn">
                        <div class="w-20 py-1" style="font-size:11px;">
                            {{ niceDateTime(createdOn.createdOn) }}
                        </div>
                    </template>
                    <template #item-status="status">
                        <div class="flex items-center">
                            <div>
                                <StatusPill v-if="status.status === 'PAID'" :text="status.status" colour="green" />
                                <StatusPill v-else-if="status.status === 'DECLINED'" :text="status.status"
                                    colour="red" />
                                <StatusPill v-else :text="status.status" colour="yellow" />
                            </div>

                            <div class="m-2" v-if="showTestCashbackButton">
                                <p class="text-xs font-medium text-nowrap text-blue-600 underline hover:font-semibold cursor-pointer"
                                    @click="showManualCashbackUpdate = true; selectedCashback = status.id">Update status
                                </p>
                            </div>
                        </div>

                    </template>
                    <template #item-internalEndUserId="internalEndUserId">
                        <div class="w-20 py-1">
                            <p style="word-break:break-all; font-size:11px;">{{ internalEndUserId.endUserId }}</p>
                        </div>
                    </template>
                    <template #item-retailer="cashback">
                        <div class="w-24 py-1">
                            <LogoAndText v-if="cashback.programOffer" :logo="cashback.programOffer.retailer.logo"
                                :text="cashback.programOffer.retailer.retailerName" />
                        </div>
                    </template>
                    <template #item-transactionValue="cashback">
                        <CashbackPill v-if="cashback.transactionData != null"
                            :text="(Math.round(cashback.transactionData.transactionAmount.amount * 100) / 100).toFixed(2)"
                            type="FIXED" :currency="cashback.transactionData.transactionAmount.currency" />
                            <CashbackPill v-else
                            text="Affiliate Transaction"
                            type="FIXED"  />
                    </template>
                    <template #item-userReceivable="cashback">
                        <CashbackPill
                            :text="(Math.round(cashback.payoutData.endUserCashbackReceivable * 100) / 100).toFixed(2)"
                            type="FIXED" :currency="cashback.payoutData.currency" />
                    </template>
                    <template #item-publisherReceivable="cashback">
                        <CashbackPill
                            :text="(Math.round(cashback.payoutData.publisherCashbackReceivable * 100) / 100).toFixed(2)"
                            type="FIXED" :currency="cashback.payoutData.currency" />
                    </template>
                    <template #item-declinedReason="cashback">
                        <StatusPill v-if="cashback.declinedReason" :text="cashback.declinedReason" colour="red" />
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import SearchBar from '@/components/SearchBar.vue'
//import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import { DateTime } from 'luxon';
import StatusPill from "@/components/StatusPill.vue";
import LogoAndText from "@/components/LogoAndText.vue";
import CashbackPill from "@/components/CashbackPill.vue";
import FormModal from "@/components/modals/FormModal.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";

export default {
    name: "Cashback-ledger",
    components: {
        Header,
        WhiteBox,
        SearchBar,
        // CustomInput,
        CustomButton,
        StatusPill,
        LogoAndText,
        CashbackPill,
        FormModal,
        CustomSelect
    },
    props: {
    },

    data() {
        return {
            lastRequest: "ALL", // ALL / USER / ID
            showTestCashbackButton: localStorage.getItem('apiType') == process.env.VUE_APP_SANDBOX_API,
            showManualCashbackUpdate: false,
            selectedCashback: undefined,
            updateCashbackRequest: {
                status: undefined
            },

            cashbackStatuses: [
                { "id": "CREATED", "text": "CREATED" },
                { "id": "BEING_VERIFIED", "text": "BEING_VERIFIED" },
                { "id": "VERIFIED", "text": "VERIFIED" },
                { "id": "RECEIVED", "text": "RECEIVED" },
                { "id": "PAID", "text": "PAID" },
                { "id": "DECLINED", "text": "DECLINED" }
                


            ],

            serverOptions: {
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength: undefined,

            userSearch: {
                userId: ""
            },
            loading: true,
            headersTable1: [
                { text: "Id", value: "id" },
                { text: "Date created", value: "createdOn" },
                { text: "Status", value: "status" },
                { text: "User id", value: "internalEndUserId" },
                { text: "Retailer", value: "retailer" },
                { text: "Transaction Value", value: "transactionValue" },
                { text: "End user receivable", value: "userReceivable" },
                { text: "Publisher receivable", value: "publisherReceivable" },
                { text: "Declined Reason", value: "declinedReason" },


            ],
            cashbackObjects: [

            ],
        }
    },
    created() {
        this.getCashbackObjects(0, 50)

    },
    methods: {
        niceDateTime(dateObject) {
            return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
        },
        async getCashbackObjectsForAnEndUser(page, size, search) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/cashback-ledger/user/${search}?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.serverItemsLength = object.totalElements
                    this.cashbackObjects = object.content
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

        async getCashbackFromId(search) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true
                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/cashback-ledger/cashback/${search}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    var array = []
                    this.serverItemsLength = 1
                    array.push(object)

                    this.cashbackObjects = array
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

        async updateCashbackById() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/cashback-ledger/cashback/${this.selectedCashback}`, {
                    method: "POST",
                    body:JSON.stringify(this.updateCashbackRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.showManualCashbackUpdate = false
                    this.selectedCashback = undefined
                    this.getCashbackObjects(this.serverOptions.page-1,this.serverOptions.rowsPerPage)
                }

            } catch (error) {
                return;
            }

        },

        async getCashbackObjects(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/cashback-ledger?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.cashbackObjects = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

    },
    computed: {

    },
    mounted() {
        document.title = "Dashboard | Cashback ledger";
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val) {
                this.getCashbackObjects(val.page - 1, val.rowsPerPage)
            }
        }
    }
}
</script>